module.exports = __webpack_public_path__ + "static/media/ludo_game.4b4eed74.jpg";